import { render, staticRenderFns } from "./UnconfirmSelectionTermSlidebar.vue?vue&type=template&id=39798127"
import script from "./UnconfirmSelectionTermSlidebar.vue?vue&type=script&lang=js"
export * from "./UnconfirmSelectionTermSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports